import { levelFilters } from '@/pages/admin/utils/level';
import type { LevelKey } from '@/pages/admin/types';

interface FilterBarProps {
  active: LevelKey | 'all';
  counts: Record<string, number>;
  total: number;
  onChange: (key: LevelKey | 'all') => void;
  onExport: () => void;
  exportDisabled: boolean;
  visibleCount: number;
}

export default function FilterBar({
  active,
  counts,
  total,
  onChange,
  onExport,
  exportDisabled,
  visibleCount,
}: FilterBarProps) {
  return (
    <div className="space-y-3">
      <div className="flex items-center justify-between gap-3">
        <div>
          <h1 className="text-lg md:text-xl font-semibold font-heading text-foreground-900">
            问诊记录
          </h1>
          <p className="text-xs text-foreground-400 mt-0.5">
            共 {total} 条 · 当前显示 {visibleCount} 条
          </p>
        </div>
        <button
          type="button"
          onClick={onExport}
          disabled={exportDisabled}
          className="h-9 px-3.5 rounded-lg bg-primary-500 hover:bg-primary-600 disabled:opacity-50 disabled:cursor-not-allowed text-background-50 text-sm font-medium transition-colors cursor-pointer whitespace-nowrap flex items-center gap-1.5 shrink-0"
        >
          <i className="ri-download-2-line"></i>
          导出 CSV
        </button>
      </div>

      <div className="flex gap-2 overflow-x-auto no-scrollbar -mx-1 px-1 pb-1">
        {levelFilters.map((item) => {
          const isActive = active === item.key;
          const count = item.key === 'all' ? total : counts[item.key] || 0;
          return (
            <button
              key={item.key}
              type="button"
              onClick={() => onChange(item.key)}
              className={`h-8 px-3 rounded-full text-xs font-medium whitespace-nowrap transition-colors cursor-pointer flex items-center gap-1.5 border ${
                isActive
                  ? 'bg-primary-500 text-background-50 border-primary-500'
                  : 'bg-background-50 text-foreground-600 border-secondary-200 hover:border-primary-300 hover:text-primary-600'
              }`}
            >
              {item.label}
              <span
                className={`text-[10px] px-1.5 rounded-full ${
                  isActive ? 'bg-background-50/25 text-background-50' : 'bg-secondary-100 text-foreground-500'
                }`}
              >
                {count}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
}